<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" style="margin-top: 20px;">
    <button routerLink="/listen-einlesen/neu" mat-raised-button color="primary" class="mb-1">
      Neue Angebotsliste
    </button>
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Alle Angebotsversionslisten
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayoutAlign="center" *ngIf="loading">
        <mat-spinner diameter="30" ></mat-spinner>
      </mat-card-content>
      <mat-card-content [hidden]="loading">
        <mat-form-field style="width: 100%;">
          <mat-label>
            Suche
          </mat-label>
          <input matInput [formControl]="search">
        </mat-form-field>

        <table mat-table [dataSource]="angebotslistenFiltered" matSort style="width: 100%;" [hidden]="angebotslistenFiltered.length == 0">
          <ng-container matColumnDef="listenName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Listenname
            </th>
            <td mat-cell *matCellDef="let element" [routerLink]="'/angebotsversionslisten/'+element.id" style="cursor: pointer;"> {{element.listenName}} </td>
          </ng-container>

          <ng-container matColumnDef="gueltigVon">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Gültig von
            </th>
            <td mat-cell *matCellDef="let element" [routerLink]="'/angebotsversionslisten/'+element.id" style="cursor: pointer;"> {{element.gueltigVon | date: 'dd.MM.yyyy'}} </td>
          </ng-container>

          <ng-container matColumnDef="gueltigBis">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Gültig bis
            </th>
            <td mat-cell *matCellDef="let element" [routerLink]="'/angebotsversionslisten/'+element.id" style="cursor: pointer;"> {{element.gueltigBis | date: 'dd.MM.yyyy'}} </td>
          </ng-container>

          <ng-container matColumnDef="erstellt">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Eingelesen am
            </th>
            <td mat-cell *matCellDef="let element" [routerLink]="'/angebotsversionslisten/'+element.id" style="cursor: pointer;"> {{element.erstellt | date: 'dd.MM.yyyy HH:mm'}} </td>
          </ng-container>

          <ng-container matColumnDef="version">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Versionsnummer
            </th>
            <td mat-cell *matCellDef="let element" [routerLink]="'/angebotsversionslisten/'+element.id" style="cursor: pointer;"> {{element.versionsnummer}} </td>
          </ng-container>

          <ng-container matColumnDef="grundliste">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Grundliste
            </th>
            <td mat-cell *matCellDef="let element" [routerLink]="'/angebotsversionslisten/'+element.id" style="cursor: pointer;">
              <span *ngIf="element.defaultList">Ja</span>
              <span *ngIf="!element.defaultList">Nein</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="for">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Gültig für
            </th>
            <td mat-cell *matCellDef="let element" [routerLink]="'/angebotsversionslisten/'+element.id" style="cursor: pointer;">
              {{element.gueltigFuer}}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Aktionen
            </th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="!element.defaultList && !element.warteAufExport">
                <button mat-raised-button color="warn" style="margin: 10px;" (click)="askDelete(element)" [disabled]="deleting">
                  <mat-icon>delete</mat-icon> Löschen
                </button>
              </div>
              <div *ngIf="!element.defaultList && element.warteAufExport">
                <small>Es werden heute Nacht noch Bestellungen zu dieser Liste exportiert. Danach können Sie die Liste löschen.</small>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['listenName', 'gueltigVon', 'gueltigBis', 'erstellt', 'version', 'grundliste', 'for', 'action']"></tr>
          <tr class="row-hover" mat-row *matRowDef="let row; columns: ['listenName', 'gueltigVon', 'gueltigBis', 'erstellt', 'version', 'grundliste', 'for', 'action'];"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
